import { Router } from '@angular/router';
import { environment } from '@app/environment';
import { Status, Type } from "@app/libs/constant";
import { clear } from "@app/services/auth-storage";

export class Common {
  public static logout(router: Router) {
    clear();
    const logoutUrl = environment.adfsUrl + '/adfs/ls/?wa=wsignout1.0';

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = logoutUrl;
    iframe.onload = iframe.onerror = () => {
      iframe.remove();
       router.navigate(['/login']);
    };
    document.body.appendChild(iframe);
  }

  public static getStatusColor(status: string): string {
    switch (status?.toLocaleLowerCase()) {
      case Status.approved:
        return '#009e73';
      case Status.pending:
        return '#ffb000';
      case Status.failed:
        return '#828282';
      case Status.rejected:
        return '#9f0f0f';
      default:
        return '#333';
    }
  }

  public static getTypeColor(status: string): string {
    switch (status?.toLocaleLowerCase()) {
      case Type.register:
        return '#009e73';
      case Type.renew:
        return '#9f0f0f';
      case Type.revoke:
        return '#3db8ff';
      default:
        return '#333';
    }
  }
}
